import { render, staticRenderFns } from "./AddCash.vue?vue&type=template&id=622f5ab0&scoped=true&"
import script from "./AddCash.vue?vue&type=script&lang=ts&"
export * from "./AddCash.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622f5ab0",
  null
  
)

export default component.exports